import React, { FC, MouseEvent, ReactElement } from "react";

import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import FolderOutlinedIcon from "@mui/icons-material/FolderOutlined";
import { Box, Button, Typography, styled } from "@mui/material";
import { TreeItem } from "@mui/x-tree-view/TreeItem";

const StyledBox = styled(Box)({
	display: "flex",
	alignItems: "center",
	padding: "0.5px",
	width: "100%",
});

const StyledTypography = styled(Typography)({
	fontWeight: "inherit",
	flexGrow: 1,
});

interface TreeFolderItemProps {
	i: number;
	id: number;
	name: string;
	modal: ReactElement;
	openModal: (value: React.SetStateAction<boolean>) => void;
}

export const TreeFolderItem: FC<TreeFolderItemProps> = (props) => {
	const treeItemStyles =
		props.i % 2 === 0
			? {
					borderRadius: "10px",
					backgroundColor: "#f2f2f2", // Light grey background color for even TreeItems
				}
			: {};

	return (
		<TreeItem
			sx={treeItemStyles}
			itemId={props.id ? props.id.toString() : props.name}
			label={
				<StyledBox>
					<FolderOutlinedIcon
						width={30}
						height={30}
						sx={{
							margin: "0 1rem",
						}}
					/>
					<StyledTypography variant="body2">{props.name}</StyledTypography>
					<Button
						variant="text"
						disabled={props.id === null || props.id === 0}
						onClick={(e: MouseEvent<HTMLButtonElement>) => {
							e.stopPropagation();
							props.openModal(true);
						}}
					>
						<EditOutlinedIcon
							width={30}
							height={30}
							sx={{
								margin: "0 1rem",
							}}
						/>
					</Button>
					{props.modal}
				</StyledBox>
			}
		>
			{props.children}
		</TreeItem>
	);
};
